<div class="request-modal">
    <div class="request-modal-body">
        <ng-content></ng-content>
    </div>
</div>
<div class="request-modal-background"></div>